// @flow
import React from "react";
import "./style.css";

class PageFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        Copyright {new Date().getFullYear()}, Spocket. All rights reserved.{" "}
        <a href="https://d3eyb8shadqthh.cloudfront.net/PrivacyPolicy.pdf" target='_blank' rel="noopener noreferrer">Privacy Policy</a>,{" "}
        <a href='https://d3eyb8shadqthh.cloudfront.net/retailer/TermsOfService.pdf' target='_blank' rel="noopener noreferrer">Terms & Conditions</a>,{" "}
        <a href='https://d3eyb8shadqthh.cloudfront.net/retailer/DataProcessingAddendum.pdf' target='_blank' rel="noopener noreferrer">Data Processing Addendum.</a>
      </div>
    );
  }
}

export default PageFooter;



// WEBPACK FOOTER //
// ./src/components/PageFooter/index.js